import React from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import Link from '../../../../../elements/Link';
import Icon from '../../../../../elements/icons/Icon';
import { isSessionSelectionControlsVisible } from '../isSessionSelectionControlsVisible';

function JoinSession(props) {
    const { event, session, onClick } = props,
        i18n = useI18n();

    if (!isSessionSelectionControlsVisible(event, session)) return null;
    if (session.is_selected) return null;

    return (
        <Link onClick={onClick}>
            <Icon
                src='/img/add-circle-positive.png'
                style={{
                    marginBottom: 4,
                }}
            />
            <br />
            {i18n['label.choose_session']}
        </Link>
    );
}

export default JoinSession;
